import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';
import { CmsProvider } from './context/CmsContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Ecosystem from './pages/Ecosystem';
import Team from './pages/Team';
import Technology from './pages/Technology';
import './App.css';

// 官网页面布局（带导航和页脚）
const App: React.FC = () => {
  return (
    <LanguageProvider>
      <CmsProvider>
        <Router>
          <PageTitle />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/ecosystem" element={<Ecosystem />} />
                <Route path="/team" element={<Team />} />
                <Route path="/technology" element={<Technology />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </CmsProvider>
    </LanguageProvider>
  );
};

// 按路由和当前语言设置浏览器标签页标题
const PageTitle: React.FC = () => {
  const { pathname } = useLocation();
  const { currentLang } = useLanguage();
  useEffect(() => {
    const titles: Record<string, [string, string]> = {
      '/': ['首页', 'Home'],
      '/about': ['关于', 'About'],
      '/ecosystem': ['生态体系', 'Ecosystem'],
      '/team': ['团队', 'Team'],
      '/technology': ['技术架构', 'Technology'],
    };
    const t = titles[pathname] || titles['/'];
    document.title = `MSL - ${currentLang === 'zh' ? t[0] : t[1]} | 元创空间实验室`;
  }, [pathname, currentLang]);
  return null;
};

export default App;